module.exports = __webpack_public_path__ + "static/p1-1ecda0cfcf05e8d3b8161781384a2839.jpg";